module.exports = __webpack_public_path__ + "media/ar-company.5a37ec0d.mp4";